import axios from 'src/axios'
import { FINDMYGUIDEROUTES } from 'src/router/Api'

export interface FindMyGuideListParams {
	page?: number
	limit?: number
	q?: string
	sort?: string
	service_type?: string
	category_id?: string
	status?: string
	is_show_by_admin?: boolean
	location?: string
}

export const getFindMyGuideCmsStatistics = async () => {
	return await axios.get(FINDMYGUIDEROUTES.cmsStatistics)
}

export const getFindMyGuideCmsListings = async (
	params: FindMyGuideListParams,
) => {
	return await axios.get(FINDMYGUIDEROUTES.cmsListings, { params })
}

export const getFindMyGuideCmsCategories = async (
	params: Pick<FindMyGuideListParams, 'page' | 'limit' | 'q'>,
) => {
	return await axios.get(FINDMYGUIDEROUTES.cmsCategories, { params })
}

export const getFindMyGuideCmsListingDetail = async (id: string) => {
	return await axios.get(FINDMYGUIDEROUTES.cmsListingItem(id))
}

export const hideFindMyGuideCmsListing = async (
	id: string,
	isHidden: boolean,
) => {
	return await axios.patch(FINDMYGUIDEROUTES.cmsListingHide(id), {
		is_show_by_admin: !isHidden,
		is_hidden: isHidden,
	})
}

export const deleteFindMyGuideCmsListing = async (id: string) => {
	return await axios.delete(FINDMYGUIDEROUTES.cmsListingItem(id))
}

export const getFindMyGuideCmsDeletedProfiles = async (
	params: Pick<FindMyGuideListParams, 'page' | 'limit' | 'q'>,
) => {
	return await axios.get(FINDMYGUIDEROUTES.cmsDeletedProfiles, { params })
}

export const restoreFindMyGuideCmsDeletedProfile = async (id: string) => {
	return await axios.post(FINDMYGUIDEROUTES.cmsRestoreDeletedProfile(id))
}
